import React, { useState } from 'react';
import { Images, X, Sparkles, Folder } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeCategory, setActiveCategory] = useState('All');

  const galleryImages = [
    // VESAK CEREMONY
    {
      id: 16,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/24tgcf4y_photo_2026-05-14_17-08-16.jpg',
      title: 'Walking Meditation under the Flags',
      description: 'Devotees in mindful walking meditation with the American and Buddhist flags above',
      category: 'Vesak',
    },
    {
      id: 17,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/61716f14_photo_2026-05-14_17-09-47.jpg',
      title: 'Vesak Outdoor Practice',
      description: 'Mixed community gathered in white attire for Vesak walking meditation',
      category: 'Vesak',
    },
    {
      id: 18,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/tg15te63_photo_2026-05-14_17-09-52.jpg',
      title: 'Mindful Procession',
      description: 'A procession of devotees moving in silence on the temple grounds',
      category: 'Vesak',
    },
    {
      id: 19,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/bto254kb_photo_2026-05-14_17-07-11.jpg',
      title: 'Indoor Vesak Meditation',
      description: 'The community in seated meditation inside the temple during Vesak',
      category: 'Vesak',
    },
    {
      id: 20,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/3sosqutg_photo_2026-05-14_17-07-06.jpg',
      title: 'Meditation Hall on Vesak',
      description: 'Devotees seated together in the meditation hall before the Buddha shrine',
      category: 'Vesak',
    },
    {
      id: 8,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/omdo8tcb_photo_2026-03-23_14-29-06.jpg',
      title: 'Vesak Decorations',
      description: 'Beautiful white flowers and lanterns during Vesak celebration',
      category: 'Vesak',
    },

    // CEREMONIES
    {
      id: 13,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/2eve8016_photo_2026-05-14_17-10-07.jpg',
      title: 'Grand Opening Ribbon Cutting',
      description: 'Sacred ribbon-cutting ceremony marking the opening of our new temple location',
      category: 'Ceremonies',
    },
    {
      id: 9,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/82h1jc4c_photo_2026-03-23_14-29-27.jpg',
      title: 'Puja Offerings',
      description: 'Candles and flowers arranged for temple puja ceremony',
      category: 'Ceremonies',
    },
    {
      id: 10,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/tlvh2mih_photo_2026-03-23_14-29-32.jpg',
      title: 'Buddha Shrine',
      description: 'Our beautiful white Buddha statue illuminated during evening ceremony',
      category: 'Ceremonies',
    },

    // MEDITATION
    {
      id: 14,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/fuztray7_photo_2026-05-14_17-07-54.jpg',
      title: 'Community Meditation',
      description: 'Devotees in deep meditation practice at the temple',
      category: 'Meditation',
    },
    {
      id: 15,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/v467lk4o_photo_2026-05-14_17-07-59.jpg',
      title: 'Sangha in Practice',
      description: 'The Sri Lankan Buddhist community sitting together in white attire',
      category: 'Meditation',
    },
    {
      id: 3,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/22idq0wk_photo_2026-03-22_15-19-05.jpg',
      title: 'Meditation Practice',
      description: 'Community member practicing meditation at the temple',
      category: 'Meditation',
    },
    {
      id: 11,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/8tl4t7k4_photo_2026-03-23_14-29-37.jpg',
      title: 'Singing Bowl Meditation',
      description: 'Traditional singing bowl used in meditation sessions',
      category: 'Meditation',
    },
    {
      id: 12,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/n9yw9f6f_photo_2026-03-23_14-29-41.jpg',
      title: 'Meditation Space',
      description: 'Peaceful meditation corner with candles and dharma books',
      category: 'Meditation',
    },

    // TEACHINGS & GUIDANCE
    {
      id: 1,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/yx99a88a_photo_2026-03-22_15-18-49.jpg',
      title: 'Spiritual Guidance',
      description: 'Bhante Dhammaloka offering personal counseling and spiritual guidance',
      category: 'Teachings',
    },
    {
      id: 2,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/1bssazwc_photo_2026-03-22_15-18-59.jpg',
      title: 'Teaching Session',
      description: 'One-on-one dharma discussion in our peaceful temple space',
      category: 'Teachings',
    },
    {
      id: 6,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/ti8lx66d_photo_2026-03-22_15-19-18.jpg',
      title: 'Our Resident Monks',
      description: 'Bhante Dhammaloka and Bhante Indasara at the temple shrine',
      category: 'Teachings',
    },
    {
      id: 7,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/twb2nwjh_photo_2026-03-22_15-19-22.jpg',
      title: 'Community Gathering',
      description: 'Sunday dharma session with children and community members',
      category: 'Teachings',
    },

    // CHILDREN
    {
      id: 4,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/ecedghex_photo_2026-03-22_15-19-09.jpg',
      title: "Children's Sunday School",
      description: 'Happy children learning and creating at our Sunday school program',
      category: 'Children',
    },
    {
      id: 5,
      url: 'https://customer-assets.emergentagent.com/job_alabama-viharaya/artifacts/p3o2d43m_photo_2026-03-22_15-19-13.jpg',
      title: 'Teaching Children',
      description: 'Bhante Dhammaloka teaching Buddhist values to young students',
      category: 'Children',
    },
  ];

  const categories = [
    { key: 'All', label: 'All Photos' },
    { key: 'Vesak', label: 'Vesak Ceremony' },
    { key: 'Ceremonies', label: 'Ceremonies' },
    { key: 'Meditation', label: 'Meditation' },
    { key: 'Teachings', label: 'Teachings' },
    { key: 'Children', label: "Children's Class" },
  ];

  // Cover for each folder
  const coverByCategory = (key) => galleryImages.find((i) => i.category === key)?.url;

  const filtered =
    activeCategory === 'All'
      ? galleryImages
      : galleryImages.filter((i) => i.category === activeCategory);

  return (
    <div className="min-h-screen bg-[#ede1c5] text-stone-900">
      {/* HERO */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.pexels.com/photos/36392913/pexels-photo-36392913.jpeg)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-[#ede1c5]" />
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-amber-400/15 blur-[140px]" />

        <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-3 text-amber-200 tracking-[0.3em] text-[11px] uppercase mb-6">
            <span className="h-px w-12 bg-amber-300/70" />
            <Sparkles size={14} />
            <span>Moments · Memory · Sangha</span>
          </div>
          <h1
            className="font-serif-display text-5xl md:text-7xl leading-[1.05] text-white max-w-3xl"
            style={{ textShadow: '0 4px 30px rgba(0,0,0,0.6)' }}
          >
            Photo<br /><span className="italic text-amber-200">gallery.</span>
          </h1>
          <p
            className="mt-6 max-w-2xl text-lg text-stone-100 leading-relaxed"
            style={{ textShadow: '0 2px 14px rgba(0,0,0,0.6)' }}
          >
            Moments from our temple community — organized by ceremonies, meditation, teachings, and Sunday school.
          </p>
        </div>
      </section>

      {/* FOLDERS (album covers) */}
      {activeCategory === 'All' && (
        <section className="py-16 border-t border-amber-500/40">
          <div className="max-w-6xl mx-auto px-6 lg:px-10">
            <div className="text-center mb-12">
              <div className="text-amber-700/80 text-[11px] tracking-[0.3em] uppercase mb-3">
                Browse by Album
              </div>
              <h2 className="font-serif-display text-3xl md:text-4xl text-stone-900">
                Open a folder
              </h2>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
              {categories.filter((c) => c.key !== 'All').map((c) => {
                const cover = coverByCategory(c.key);
                const count = galleryImages.filter((i) => i.category === c.key).length;
                return (
                  <button
                    key={c.key}
                    onClick={() => setActiveCategory(c.key)}
                    data-testid={`folder-${c.key}`}
                    className="group relative aspect-[4/5] overflow-hidden rounded-2xl border border-amber-600/40 hover:border-amber-700 transition-all shadow-lg hover:shadow-2xl text-left"
                  >
                    <img
                      src={cover}
                      alt={c.label}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/45 to-black/15" />
                    {/* folder tab decorations */}
                    <div className="absolute top-0 left-4 right-4 h-2 bg-amber-700/80 rounded-b-md" />
                    <div className="absolute bottom-0 left-0 right-0 p-5">
                      <div className="flex items-center gap-2 text-amber-200 text-[10px] tracking-[0.3em] uppercase mb-2">
                        <Folder size={12} />
                        <span>{count} photos</span>
                      </div>
                      <h3 className="font-serif-display text-2xl text-white leading-tight drop-shadow-md">
                        {c.label}
                      </h3>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* FILTER BAR (always visible) */}
      <section className="py-10 border-t border-amber-500/40 bg-[#e3d4af]">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 flex flex-wrap items-center justify-center gap-2">
          {categories.map((c) => (
            <button
              key={c.key}
              onClick={() => setActiveCategory(c.key)}
              data-testid={`filter-${c.key}`}
              className={`px-5 py-2.5 rounded-full text-xs tracking-[0.15em] uppercase transition-all ${
                activeCategory === c.key
                  ? 'bg-amber-700 text-white shadow-md shadow-amber-900/30'
                  : 'bg-white/70 text-stone-700 border border-amber-600/40 hover:border-amber-700 hover:text-amber-800'
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>
      </section>

      {/* GRID */}
      <section className="py-20 border-t border-amber-500/40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {activeCategory !== 'All' && (
            <div className="mb-10 text-center">
              <div className="text-amber-700/80 text-[11px] tracking-[0.3em] uppercase mb-2">
                Folder · {filtered.length} photos
              </div>
              <h2 className="font-serif-display text-3xl md:text-4xl text-stone-900">
                {categories.find((c) => c.key === activeCategory)?.label}
              </h2>
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((image) => (
              <div
                key={image.id}
                onClick={() => setSelectedImage(image)}
                data-testid={`gallery-image-${image.id}`}
                className="group relative overflow-hidden rounded-2xl border border-amber-600/40 hover:border-amber-700 transition-all cursor-pointer aspect-square shadow-md"
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/55 to-transparent opacity-0 group-hover:opacity-95 transition-opacity duration-500" />
                <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 text-[9px] tracking-[0.25em] uppercase text-white bg-black/55 backdrop-blur-md px-2.5 py-1 rounded-full">
                  <Folder size={10} /> {image.category}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                  <h3 className="font-serif-display text-xl text-white mb-1.5 leading-tight drop-shadow-md">
                    {image.title}
                  </h3>
                  <p className="text-sm text-stone-100 leading-relaxed drop-shadow">
                    {image.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SHARE */}
      <section className="py-20 bg-[#d4c094] border-t border-amber-500/40">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <Images className="mx-auto text-amber-800 mb-5" size={28} />
          <h3 className="font-serif-display text-3xl md:text-4xl text-stone-900 mb-4">
            Share your <span className="italic text-amber-800">moments.</span>
          </h3>
          <p className="text-stone-700 leading-relaxed">
            These photos capture the essence of our temple community. To share your photos from
            temple events, please contact us at{' '}
            <a href="mailto:alvihara@gmail.com" className="text-amber-800 hover:text-amber-900 underline-offset-4 hover:underline">
              alvihara@gmail.com
            </a>
            .
          </p>
        </div>
      </section>

      {/* LIGHTBOX */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 p-4 backdrop-blur-sm"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-amber-300 transition-colors"
            onClick={() => setSelectedImage(null)}
            data-testid="lightbox-close"
          >
            <X size={32} />
          </button>
          <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
            />
            <div className="mt-5 text-center">
              <div className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.3em] uppercase text-amber-300 mb-2">
                <Folder size={11} /> {selectedImage.category}
              </div>
              <h3 className="font-serif-display text-2xl text-white mb-1">{selectedImage.title}</h3>
              <p className="text-stone-300 text-sm">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
